module.exports = __webpack_public_path__ + "img/kis_no.3ceb2173.png";